module.exports = __webpack_public_path__ + "img/MuhammadHamo.5dfa09dc.jpg";